import {Task} from './task';

export class Lab {

  constructor(public id: number,
              public title: string,
              public desc: string,
              public totalscore: number,
              public tasks:Array<Task>){

  }
}
